import { useContent } from '@wix/funnel-builder-lizard'
import React, { FC, useMemo } from 'react'

import { PageLoggerContext } from './PageLoggerContext'
import { useFlowLogger } from './useFlowLogger'

export const PageLoggerProvider: FC = ({ children }) => {
  const flowLogger = useFlowLogger()
  const { biSlug: pageBiSlug } = useContent()
  const pageLogger = useMemo(() => flowLogger.createPageLogger({ pageBiSlug }), [flowLogger, pageBiSlug])
  return <PageLoggerContext.Provider value={pageLogger}>{children}</PageLoggerContext.Provider>
}
